import { z } from 'zod';
import { ZBaseIntegrationConfig } from './base.js';
export const STAPE_INTEGRATION_NAME = 'stape';
export const ZStapeIntegrationConfig = ZBaseIntegrationConfig.extend(z.object({
    integrationName: z.literal(STAPE_INTEGRATION_NAME),
    category: z.literal('analytics'),
    credentials: z.object({}).optional(),
    settings: z.object({}).optional(),
}).shape);
//# sourceMappingURL=stape.js.map